/* Parttyhub sticker animations: scroll-in reveal + subtle scroll parallax.
   Markup: <img data-ph-sticker [data-ph-parallax="24"] style="--ph-rot:-12deg"> */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var stickers = Array.prototype.slice.call(document.querySelectorAll('[data-ph-sticker]'));
    if (!stickers.length) return;

    if (reduce) {
      stickers.forEach(function (el) { el.classList.add('ph-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('ph-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    stickers.forEach(function (el) { io.observe(el); });

    // Subtle parallax drift while in view
    var px = stickers.filter(function (el) { return el.hasAttribute('data-ph-parallax'); });
    if (!px.length) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        px.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          var center = r.top + r.height / 2;
          var prog = (center - vh / 2) / vh; // ~ -0.5 .. 0.5
          var amt = parseFloat(el.getAttribute('data-ph-parallax')) || 20;
          el.style.setProperty('--ph-py', (prog * amt * -1).toFixed(1) + 'px');
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // Re-init in Shopify theme editor when sections re-render
  document.addEventListener('shopify:section:load', init);
})();

/* Toggle a solid navbar once the page is scrolled past the hero top */
(function () {
  function onScroll() {
    document.body.classList.toggle('ph-scrolled', (window.scrollY || window.pageYOffset) > 60);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* Scroll-in reveal — text & media fade up quickly as they enter view.
   Scoped to main content; hero, header and footer are left untouched. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SEL = 'h1,h2,h3,h4,h5,h6,p,li,img,figure,blockquote';

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add('ph-revealed');
        io.unobserve(en.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

  function collect(root) {
    document.documentElement.classList.add('ph-reveal-on');
    var scope = root || document.getElementById('MainContent') || document.querySelector('main') || document.body;
    var nodes = Array.prototype.slice.call(scope.querySelectorAll(SEL));
    nodes.forEach(function (n) {
      if (n.hasAttribute('data-ph-reveal') || n.hasAttribute('data-ph-sticker')) return;
      if (n.closest('[id^="ph-hero-"]')) return;               // hero paints immediately
      if (n.closest('#header-group, footer, .ph-header, cart-drawer, .ph-pt')) return;
      if (n.parentElement && n.parentElement.closest('[data-ph-reveal]')) return; // dedup nesting
      n.setAttribute('data-ph-reveal', '');
      io.observe(n);
    });
  }

  function start() { collect(); }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', function (e) { collect(e.target); });
})();
